function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import isNumber from 'lodash/isNumber';
import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Segmentation } from 'common/types/reports/query';
import { withStyles } from 'common/util/react';
import { SegmentValue } from 'common/query-builder/query-block/segment-menu/types';
import { PropertyFilter } from 'common/widgets/property-filter-menu/models/property-filter';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonSize } from 'common/components/button/constants';
import { SelectReact } from 'common/components/select';
import { generateStepList, getStepLabel } from '../utils';
import css from './index.module.styl?inline';
import styles from './index.module.styl';
type Props = {
  className?: string;
  stepCount: number;
  selected: Segmentation;
  onChange: (selection: SegmentValue | Partial<PropertyFilter>) => void;
};
export const BehavioralStepSelectionSubItem = withStyles((props: Props) => {
  const selection = props.selected.behavior || props.selected;
  const sections = useMemo(() => {
    return generateStepList(selection, props.stepCount);
  }, [selection, props.stepCount]);
  const label = useMemo(() => {
    if (!sections[0]) return null;
    let startStepNumber = selection.startStepNumber;
    if (isNumber(selection.endStepNumber) && sections[0].items.length <= selection.endStepNumber && sections[0].items.some(item => item.label === "All Steps")) {
      startStepNumber = null;
    }
    return getStepLabel(sections, startStepNumber);
  }, [selection, sections]);
  const isStepNumberValid = isNumber(selection.startStepNumber) || selection.startStepNumber === null;
  if (!isStepNumberValid) {
    return null;
  }
  return <SelectReact className={clsx(styles.subitemSelect, props.className)} elref='stepSelect' disableSearch tabIndex={-1} theme={SelectTheme.QbSubitem} size={ButtonSize.Small} label={label} sections={sections} onChange={ev => {
    const startStepNumber = ev.detail.item.value;
    const endStepNumber = isNumber(startStepNumber) ? startStepNumber + 1 : null;
    if (props.selected.behavior) {
      props.onChange(_objectSpread(_objectSpread({}, props.selected), {}, {
        behavior: _objectSpread(_objectSpread({}, props.selected.behavior), {}, {
          startStepNumber,
          endStepNumber
        })
      }));
    } else {
      props.onChange(_objectSpread(_objectSpread({}, props.selected), {}, {
        startStepNumber,
        endStepNumber
      }));
    }
  }} />;
}, css);